import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../interfaces'

import abTest from './abTest'
import account from './account'
import additionalOption from './additionalOption'
import affiliatePoint from './affiliatePoint'
import agreement from './agreement'
import banner from './banner'
import branch from './branch'
import card from './card'
import cashReceipt from './cashReceipt'
import chargePoint from './chargePoint'
import common from './common'
import deliveryGroup from './deliveryGroup'
import deliveryInfo from './deliveryInfo'
import deliveryManager from './deliveryManager'
import error from './error'
import gift from './gift'
import merchants from './merchants'
import mobile from './mobile'
import moneyToken from './moneyToken'
import orderProcessor from './orderProcessor'
import orderSheetCoupon from './orderSheetCoupon'
import orderSheetProducts from './orderSheetProducts'
import orderTotal from './orderTotal'
import payLater from './payLater'
import paymentMethod from './paymentMethod'
import payNext from './payNext'
import personalCustomsClearance from './personalCustomsClearance'
import pointPayment from './pointPayment'
import purchaser from './purchaser'
import receiverInfo from './receiverInfo'
import result from './result'
import reward from './reward'
import rewardPoint from './rewardPoint'
import voucher from './voucher'
import waiting from './waiting'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        abTest,
        account, // keep
        affiliatePoint, // keep
        agreement, // keep
        additionalOption, // keep
        banner, // keep
        branch, // keep
        card, // keep
        cashReceipt, // keep
        chargePoint, // keep
        common, // keep
        deliveryGroup, // keep
        deliveryInfo, // keep
        deliveryManager,
        error, // keep
        gift, // keep
        merchants, // keep
        mobile, // keep
        moneyToken, // keep
        orderProcessor, // keep
        orderSheetCoupon, // keep
        orderSheetProducts, // keep
        orderTotal, // keep
        payLater, // keep
        paymentMethod, // keep
        payNext, // keep
        personalCustomsClearance, // keep
        pointPayment, // keep
        purchaser, // keep
        receiverInfo, // keep
        result,
        reward, // keep
        rewardPoint, // keep
        router: routerReducer,
        voucher, // keep
        waiting, // keep
    })

export default createRootReducer

export type RootReducer = ReturnType<typeof createRootReducer>
